import { useEffect, useState } from 'react'

interface SessionCounterProps {
  startedAt: string
}

function formatDuration(seconds: number): string {
  const h = Math.floor(seconds / 3600)
  const m = Math.floor((seconds % 3600) / 60)
  const s = seconds % 60
  return [h, m, s].map((n) => String(n).padStart(2, '0')).join(':')
}

export default function SessionCounter({ startedAt }: SessionCounterProps) {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const handle = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(handle)
  }, [])

  const elapsed = Math.max(0, Math.floor((now - new Date(startedAt).getTime()) / 1000))

  return (
    <p className="mt-4 text-center text-3xl font-mono tabular-nums tracking-tight text-text-primary">
      {formatDuration(elapsed)}
    </p>
  )
}
